/** @fileoverview list_dashboards の共通定数 */

/** ツール名（単一参照点） */
export const LIST_DASHBOARDS_NAME = "list_dashboards" as const;

/** LLM へ提示する説明文 */
export const LIST_DASHBOARDS_DESC = `Lists dashboards for a workspace (organization).

Use when a user asks which dashboards exist in a workspace or wants to choose one.

Input:
- 'organizationId' (required): The workspace/organization ID that owns the dashboards.

Notes:
- Read-only; does not create, update, or delete anything.
- Returns: { organizationId, dashboardOrder, dashboards: [{ id, name, description, createdAt, updatedAt, items: [{ id, name, description, type, featureID? }] }] }.`;
